export default __webpack_public_path__ + "static/media/Group-User.09556cb5.svg";